import { useNavigate } from 'react-router-dom';

import { Box, Button, Card, Container, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AgencyDealsList from '../components/AgencyDealsList';
import AgencyHomePromoMessage from '../components/AgencyHomePromoMessage';
import { useAuth } from '../components/AuthContext';
import MonthlyStatsOverview from '../components/Statistics/MonthlyStatsOverview';
import { useOrganizationInDb } from '../hooks/useApiQueries';

const ctaButtonSx = {
  flex: 1,
  minWidth: 0,
  height: 'auto',
  minHeight: '55px',
  px: 1.5,
  py: 1,
  lineHeight: 1.25,
};

const AgencyReprisePage = () => {
  const auth = useAuth();
  const theme = useTheme();
  const navigate = useNavigate();

  const currentUser = auth ? auth.currentUser : null;
  const currentUserRole = currentUser?.data?.data?.role;
  const orgId = currentUser?.data?.organization?.value;

  const { data: organizationInfo } = useOrganizationInDb(orgId);
  const franchiseIdRaw =
    currentUser?.data?.organization_franchise_id ??
    organizationInfo?.franchise_id ??
    organizationInfo?.bf580a2a61f8c16cae1aa13670de6fa21184592f;
  const franchiseId = franchiseIdRaw != null ? String(franchiseIdRaw) : undefined;

  return (
    <Container maxWidth={false} sx={{ padding: theme.spacing(4), backgroundColor: theme.palette.background.default }}>
      <Grid
        container
        spacing={4}
        sx={{ marginTop: theme.spacing(0), width: '100%', maxWidth: 1300, mx: 'auto', marginBottom: theme.spacing(1) }}
      >
        <Grid container item sm={5} xs={12} sx={{ paddingLeft: '0 !important' }}>
          <Card
            elevation={5}
            sx={{ padding: theme.spacing(2), display: 'flex', flexDirection: 'column', marginTop: theme.spacing(0) }}
          >
            <AgencyHomePromoMessage franchiseId={franchiseId} slot="reprise" />
            {/* Les deux CTA restent toujours côte à côte : flexWrap nowrap + flex 1 sur chaque
                bouton. Quand la carte est étroite, c'est le libellé qui passe sur deux lignes
                (height auto), jamais le bouton qui descend sous l'autre. */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignItems: 'stretch',
                gap: 1,
                margin: '8px auto !important',
                width: '100%',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                type="button"
                className="ActionButton"
                sx={ctaButtonSx}
                onClick={() => {
                  // Même comportement que le menu « Demande de CG » du header :
                  // FormCGIA v2 consomme cette clé au mount pour démarrer une session vierge.
                  sessionStorage.setItem('form_cgia_new_session', '1');
                  navigate('/form-cg');
                }}
              >
                📄 Je fais ma carte grise
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="button"
                className="ActionButton"
                sx={ctaButtonSx}
                onClick={() => navigate('/cotation')}
              >
                🚗 Demande de reprise
              </Button>
            </Box>
          </Card>
        </Grid>
        <Grid container item xs={7}>
          <Typography variant="body1" gutterBottom align="left" sx={{ marginBottom: theme.spacing(1) }}>
            Vos statistiques du mois en cours
          </Typography>
          {currentUser?.data?.organization?.value ? (
            <MonthlyStatsOverview
              role={currentUserRole}
              franchise={''}
              orgName={currentUser?.data?.organization?.name}
            />
          ) : (
            <Typography variant="body2" gutterBottom align="left" sx={{ marginBottom: theme.spacing(1) }}>
              Il semblerait y avoir un problème dans la configuration de votre compte, veuillez nous contacter au 07 80 94
              97 37.
            </Typography>
          )}
        </Grid>
        {currentUser?.data?.organization?.value && (
          <Box sx={{ width: '100%' }}>
            <AgencyDealsList orgId={currentUser?.data?.organization?.value} />
          </Box>
        )}
      </Grid>
    </Container>
  );
};

export default AgencyReprisePage;
